import React, { useState } from "react";
import { toast } from "react-toastify";
import { Loader } from "react-bootstrap-typeahead";
import { useCreateTeleDispositionMutation } from "../../../../Services/Telephony/Telephony";

interface IProps {
  closeModal: () => void;
  setData: React.Dispatch<React.SetStateAction<any[]>>;
  data: any[];
  SetLiftingAddDate: any;
  selectedTeam: any;
  refetch: any;
  process:any
}

const AddNewTeleDispositionModal: React.FC<IProps> = ({
  closeModal,
  setData,
  data,
  SetLiftingAddDate,
  selectedTeam,
  refetch,
  process
}) => {
  const [topic, setTopic] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [trigger, {isLoading}] = useCreateTeleDispositionMutation();

  const handleTopicChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTopic(event.target.value);
  };

  const removeLevelProperty = (nodes: any[]) => {
    return nodes.map(({ level, sub_topics, ...rest }) => ({
      ...rest,
      sub_topics: sub_topics ? removeLevelProperty(sub_topics) : [],
    }));
  };

  const getMutationErrorMessage = (err: unknown): string => {
    const e = err as { data?: Record<string, unknown> };
    const data = e?.data;
    if (!data || typeof data !== "object") {
      return "An error occurred while adding Disposition";
    }
    const nfe = data.non_field_errors;
    if (Array.isArray(nfe) && nfe.length > 0 && typeof nfe[0] === "string") {
      return nfe[0];
    }
    const detail = data.detail;
    if (typeof detail === "string") return detail;
    for (const v of Object.values(data)) {
      if (Array.isArray(v) && v.length > 0 && typeof v[0] === "string") {
        return v[0];
      }
      if (typeof v === "string") return v;
    }
    return "An error occurred while adding Disposition";
  };

  const handleAdd = async () => {
    setIsSubmitting(true);

    const payload = {
      disposition: topic.trim(),
      sub_disposition: [],
      team: selectedTeam,
      type: process,
    };

    try {
      await trigger(payload).unwrap();
      toast.success("Disposition added successfully");
      refetch();
      closeModal();
      setTopic("");
    } catch (error) {
      toast.error(getMutationErrorMessage(error));
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <div>
      <div className="mt-4">
        <input
          type="text"
          className="form-control"
          placeholder="Topic"
          value={topic}
          onChange={handleTopicChange}
          disabled={isSubmitting} // Disable input while submitting
        />
      </div>
      <div className="d-flex justify-content-end mt-4">
        <button
          type="reset"
          className="btn btn-sm btn-white me-2"
          onClick={closeModal}
          disabled={isSubmitting} // Disable button while submitting
        >
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-sm btn-primary"
          onClick={handleAdd}
          disabled={!topic.trim() || isSubmitting} // Disable button if topic is empty or submitting
        >
          {isLoading ? <>Adding... <Loader /></> : "Add"}
        </button>
      </div>
    </div>
  );
};

export default AddNewTeleDispositionModal;
